export default {
      id: "demarches_particuliers-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#demarches_particuliers-usage",
      toString: function () {
        return this.url;
      }
    }